import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ActiveTab } from "hooks/useActiveTab";

type InitialState = {
  activeTabs: Partial<{ [activeTab in ActiveTab]: string }>;
};

const initialState: InitialState = {
  activeTabs: {},
};

export const tabsSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    setActiveTab: (
      state,
      action: PayloadAction<{ id: ActiveTab; activeTab: string }>,
    ) => {
      const { id, activeTab } = action.payload;

      state.activeTabs = {
        ...state.activeTabs,
        [id]: activeTab,
      };
    },
    clearActiveTabs: (state, action: PayloadAction<{ id: ActiveTab }>) => {
      const { id } = action.payload;

      const newState = { ...state.activeTabs };
      delete newState[id];

      state.activeTabs = newState;
    },
  },
});

export const { setActiveTab, clearActiveTabs } = tabsSlice.actions;

export const selectTabs = (state: RootState) => {
  return state.tabs.activeTabs;
};

export default tabsSlice.reducer;
